<template>
    <div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <boton-atras :nombre_ruta="'Menu'"/>
          </div>
          <div class="col-md-12 text-center">
             <h1 class="bold300 text-uppercase" style=" font-weight:500;">Recursos a Municipios</h1>
          </div>
          <div v-for="(link, index) in links" :key="index" class="col-md-6">
                    <a v-if="link.type === 'external'" :href="link.url" target="_blank"><cardsMenu  :card="link"/></a>
        <router-link v-else :to="{name: link.route}"><cardsMenu  :card="link"/></router-link>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import cardsMenu from '../../../components/cardsMenu.vue';
import botonAtras from '../../button-atras'

export default {
components: {cardsMenu, botonAtras},
data(){
  return {
    data: [],
    links:[
       {id:1, esIcono:false, recurso:"img/rendicion-ctas/recursos-mpios.jpg", titulo: 'Presupuesto de Egresos para el Ejercicio 2018', type: 'external', url: this.urlServe + 'rendicion-ctas/recursos-mpios/informacion/PAM2018.pdf' },
        {id:2, esIcono:false, recurso:"img/armonizacion/PFM.jpg", titulo: 'Participaciones Federales a Municipios', type: 'internal', route: 'Participaciones-Federales-Municipios' },
        {id:3, esIcono:false, recurso:"img/armonizacion/AFM.jpg", titulo: 'Aportaciones Federales a Municipios', type: 'internal', route: 'Aportaciones-Federales-Municipios' },
        {id:4, esIcono:false, recurso:"img/armonizacion/partic-aportac.jpg", titulo: 'Participaciones y Aportaciones a Municipios 2001-2012', type: 'internal', route: 'Participaciones-Aportaciones-Mun' },
        {id:5, esIcono:false, recurso:"img/armonizacion/PDR.jpg", titulo: 'Proyectos de Desarrollo Regional', type: 'internal', route: 'Proyectos-Desarrollo-Regional' },
        {id:6, esIcono:false, recurso:"img/armonizacion/fortalece.jpg", titulo: 'Fondo para el Fortalecimiento de la Infraestructura Estatal y Mpal. (FORTALECE)', type: 'internal', route: 'Fondo-Fortalec-Infra-Estatal-Mpal' },
        {id:7, esIcono:false, recurso:"img/armonizacion/fronteras.jpg", titulo: 'Fondo para Fronteras', type: 'internal', route: 'Fondo-Fronteras' },
        {id:8, esIcono:false, recurso:"img/armonizacion/fortaseg.jpg", titulo: 'Subsidio para el Fortalecimiento del Desempeño en Materia de Seguridad Pública (FORTASEG)', type: 'internal', route: 'Subsidio-FORTASEG' }
    ],
  };
},

}
</script>
